import styled from 'styled-components';
import {Colors} from "components/constants";

export const Background = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;